module.exports = __webpack_public_path__ + "img/logo_sheraton@3x.31f8b71c.png";